// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"962":"home","966":"login"}[chunkId] + "." + {"962":"aa81beeb","966":"6c258acf"}[chunkId] + ".css";
};